export function addRegionToLocale(locale: string) {
    if (locale == "en") {
        const result = "en-GB"
        console.log("Setting moment locale", result)
        return result
    }
    else return locale
}